import { render, staticRenderFns } from "./vision.vue?vue&type=template&id=3af74701&scoped=true"
import script from "./vision.vue?vue&type=script&lang=js"
export * from "./vision.vue?vue&type=script&lang=js"
import style0 from "./vision.vue?vue&type=style&index=0&id=3af74701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af74701",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopSectionTitle: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/TopSectionTitle.vue').default,BtnReadmore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-readmore.vue').default})
